import { UserAddressModel } from '../../auth/_models';

export interface PersonalInfoFormValues {
  firstname: string;
  lastname: string;
  middlename: string;
  dob: string;
  occupation: string;
  phoneNumber: string;
}

export interface AddPropertyFormValues {
  dob: string;
  uniteNo: string;
  rnt: string;
  property: string;
  address: string;
}

export interface RentalInfoFormProps {
  rent: number | null;
  dueDay: number;
  leaseStart: string;
  leaseEnd: string;
  document: string;
}
export interface formProps {
  firstname: string | undefined;
  lastname: string | undefined;
  dob: Date | null | undefined;
  occupation: string | undefined;
  industry: string | undefined;
  address: UserAddressModel | undefined;
  house: string | undefined;
  street: string | undefined;
  city: string | undefined;
  province: string | undefined;
  provinceCode: string | undefined;
  postal: string | undefined;
  country: string | { icon: string; name: string } | undefined;
  countryCode: string | undefined;
}
export interface editPropertyProps {
  uniteNo: string;
  rnt: string;
  property: string;
  address: string;
  street: string;
  house: string;
  city: string;
  province: string;
  provinceCode?: string;
  postal: string;
  country: string;
  rent: number | null;
  dueDay: number;
  leaseStart: string;
  leaseEnd: string;
  document: string;
}
export interface EditCardProps {
  city: string;
  provinceCode: string;
  countryCode: string;
  postal: string;
  address: string;
}
export interface AddCardFormValues {
  cardHolderName: string;
  email: string;
  address: string;
  unitNumber: string;
  house: string;
  street: string;
  postal: string;
  city: string;
  province: string;
  provinceCode: string;
  country: string;
}
export interface AddPropertyManager {
  uniteNo: string;
  property: string;
  address: string;
  street: string;
  house: string;
  city: string;
  province: string;
  provinceCode?: string;
  postal: string;
  country: string;
  rent: number | null;
  dueDay: number;
  leaseStart: string;
  leaseEnd: string;
  document: string;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
  question: string;
  answer: string;
}
export interface AddLeaseDates {
  leaseStart: string;
  leaseEnd: string;
}
export interface AddEquifaxBuilding {
  leaseStart: string;
  leaseEnd: string;
  address: string;
  house: string;
  street: string;
  city: string;
  province: string;
  provinceCode: string;
  country: string;
  countryCode: string;
  postal: string;
  unitNumber: string;
}
export interface RentAddressFormValues {
  rent: number | null;
  dueDay: number;
  address: string;
  unitNo: string;
  street: string;
  house: string;
  city: string;
  province: string;
  provinceCode?: string;
  postal: string;
  country: string;
}

export interface RentAddressOccupationFormValues extends RentAddressFormValues {
  occupation: string;
}

export interface ManualAddressValues {
  address: string;
  unitNumber: string;
  street: string;
  house: string;
  postal: string;
  city: string;
  province: string;
  provinceCode: string;
  country: string;
}

export interface UpdatePaymentOptionValues {
  address: string;
  unitNumber: string;
  street: string;
  house: string;
  postal: string;
  city: string;
  province: string;
  provinceCode: string;
  country: string;
  isDefault: boolean;
}
export interface RNTFormValues {
  rent: number | null;
  dueDay: number;
  address: string;
  unitNo: string;
  street: string;
  house: string;
  city: string;
  province: string;
  provinceCode: string;
  postal: string;
  country: string;
}

export enum BuildingType {
  Personal = 'personal',
  Business = 'business',
  Both = 'both',
}

export interface FullRNTFormValues {
  uniteNo: string;
  rnt: string;
  property: string;
  address: string;
  street: string;
  house: string;
  city: string;
  province: string;
  provinceCode: string;
  postal: string;
  country: string;
  rent: number | null;
  dueDay: number;
  leaseStart: string;
  leaseEnd: string;
  document: string;
  buildingType: BuildingType;
}
